import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';
import Ceo from '../../assets/images/ceo.jpg';
import SERV from '../../assets/images/service3.jpg';
import { motion } from 'framer-motion'; // Importation de Framer Motion

const ServicePageConcierge = () => {
  return (
    <section id="main-container" className="main-container" style={{ backgroundImage: 'url(images/assets/ban4.jpg)' }}>
      <div className="container">
        <div className="row">
          <div className="col-xl-3 col-lg-4">
            <div className="sidebar sidebar-left">
              <div className="widget">
                <h3 className="widget-title">Solutions</h3>
                <ul className="nav service-menu">
                  <li ><Link to="/Securite-residentielle-industrielle">Sécurité résidentielle et industrielle</Link></li>
                  <li><Link to="/Protection-rapprochee">Protection rapprochée</Link></li>
                  <li  className="active"><Link to="/Surveillance-de-sites-minierse">Surveillance de sites miniers</Link></li>
                  <li><Link to="/Transport-securise">Transport sécurisé</Link></li>
                 
                </ul>
              </div>

              <div className="widget">
                <div className="quote-item quote-border">
                  <div className="quote-text-border">
                   L’excellence au service de votre protection. 
                  </div>
                  <div className="quote-item-footer">
                    <img className="testimonial-thumb" src={Ceo} alt="testimonial" />
                    <div className="quote-item-info">
                      <h3 className="quote-author text-dark">Kanku Kalala Pierre</h3>
                      <span className="quote-subtext">Administrateur Général <br /> et Associé Unique</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xl-8 col-lg-8">
            <div className="content-inner-page">
              {/* Titre avec animation */}
              <motion.h2
                className="column-title mrt-0 fw-bold"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1 }}
              >
            Surveillance de sites miniers
              </motion.h2>

              <div className="row">
                 <div className="col-md-12">
                  <div className="card mb-4" >
  <img src={SERV} className="card-img-top img-fluid hover-shadow" alt="Sunset Over the Sea"/>
 
</div>
                 </div>
                <div className="col-md-12">
                  {/* Paragraphe animé */}
                  <motion.p
                    className="text-left"
                    style={{ fontFamily: 'Times', fontSize: '20px' }}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.5, duration: 1 }}
                  >
               GEKAS Security and Consulting SARL met à disposition son expertise pour la surveillance de sites miniers, un domaine hautement stratégique exposé à de nombreux risques : vols, intrusions, sabotages, conflits communautaires ou encore atteintes à l’environnement. Conscients de l’importance économique et sécuritaire de ces sites pour la République Démocratique du Congo, nous avons développé des solutions intégrées alliant surveillance humaine, dispositifs technologiques et intelligence terrain.
                  </motion.p>
                  <motion.p
                    className="text-left"
                    style={{ fontFamily: 'Times', fontSize: '20px' }}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 1, duration: 1 }}
                  >
               Nos équipes sont composées d’agents rigoureusement formés aux réalités du terrain minier, capables d’évoluer dans des zones isolées ou à risques. Grâce à un système de rondes régulières, de contrôle d’accès strict, de vidéosurveillance et d’alerte en temps réel, nous assurons une vigilance continue et dissuasive. Chaque intervention est encadrée par des protocoles de sécurité clairs, adaptés aux spécificités du site surveillé et en coordination avec les forces locales si nécessaire.
                  </motion.p>

                   <motion.p
                    className="text-left"
                    style={{ fontFamily: 'Times', fontSize: '20px' }}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 1, duration: 1 }}
                  >
              GEKAS s’engage à protéger non seulement les infrastructures minières, mais aussi les ressources, les équipements et le personnel sur place. Notre objectif est de garantir un environnement sécurisé et stable, favorable à la productivité et à l’investissement. En choisissant GEKAS, les opérateurs miniers bénéficient d’un partenaire fiable, discret et engagé dans la sécurisation durable de leurs activités.


                  </motion.p>
                </div>
              </div>

              <div className="gap-40"></div>

       

              <div className="gap-40"></div>

         

              <div className="gap-40"></div>

              {/* Call to Action avec animation sur le bouton */}
              <div className="call-to-action classic">
                <div className="row align-items-center">
                  <div className="col-md-8 text-center text-md-left">
                    <div className="call-to-action-text">
                      <h4 className="action-title">Êtes-vous intéressé par ce service ?</h4>
                    </div>
                  </div>
                  <div className="col-md-4 text-center text-md-right mt-3 mt-md-0">
                    <motion.div
                      className="call-to-action-btn"
                      whileHover={{ scale: 1.1, color: '#ffffff', backgroundColor: '#ff9800' }}
                    >
                      <Link to="/Contact" className="btn btn-warning">
                        Contactez-nous
                      </Link>
                    </motion.div>
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ServicePageConcierge;
